export default {
    title: 'Bestillingen din behandles.'
}
